import { render, staticRenderFns } from "./EditAttachItem.vue?vue&type=template&id=9fb3a8be&"
import script from "./EditAttachItem.vue?vue&type=script&lang=js&"
export * from "./EditAttachItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fb3a8be')) {
      api.createRecord('9fb3a8be', component.options)
    } else {
      api.reload('9fb3a8be', component.options)
    }
    module.hot.accept("./EditAttachItem.vue?vue&type=template&id=9fb3a8be&", function () {
      api.rerender('9fb3a8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/EditAttachments/EditAttachItem.vue"
export default component.exports